import { render, staticRenderFns } from "./Pengaduan.vue?vue&type=template&id=2f03ca0f&scoped=true&"
import script from "./Pengaduan.vue?vue&type=script&lang=js&"
export * from "./Pengaduan.vue?vue&type=script&lang=js&"
import style0 from "./Pengaduan.vue?vue&type=style&index=0&id=2f03ca0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f03ca0f",
  null
  
)

export default component.exports